import { render, staticRenderFns } from "./satisfactionSurveyDetail.vue?vue&type=template&id=c2625adc"
import script from "./satisfactionSurveyDetail.vue?vue&type=script&lang=js"
export * from "./satisfactionSurveyDetail.vue?vue&type=script&lang=js"
import style0 from "./satisfactionSurveyDetail.vue?vue&type=style&index=0&id=c2625adc&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2625adc')) {
      api.createRecord('c2625adc', component.options)
    } else {
      api.reload('c2625adc', component.options)
    }
    module.hot.accept("./satisfactionSurveyDetail.vue?vue&type=template&id=c2625adc", function () {
      api.rerender('c2625adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/etr/satisfactionSurveyDetail.vue"
export default component.exports